import React, { useEffect, useState } from "react";
import { GitBranch, Loader2, Check } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

// Shown only for dev-type workflows (a Vibe Coding stage exists). Links a GitHub/GitLab repo so CI/CD webhook status lands on the right stage.
export const isDevFlow = (steps) => (steps || []).some((s) => s.agent_id === "coding");

const normalize = (v) => (v || "").trim().replace(/^(https?:\/\/)?(www\.)?[\w.-]+\.[a-z]{2,}(:\d+)?\//i, "").replace(/\.git$/, "").replace(/\/-\/.*$/, "").replace(/\/+$/, "");

export function RepoField({ value, onChange, onSave, saving, disabled }) {
  const [repos, setRepos] = useState([]);
  useEffect(() => {
    api.get("/integrations").then((r) => {
      const on = (r.data.items || []).filter((it) => ["github", "gitlab"].includes(it.id) && it.connected).map((it) => it.id);
      if (!on.length) return;
      Promise.allSettled(on.map((id) => api.get(`/integrations/${id}/repos`))).then((rs) =>
        setRepos(rs.flatMap((x) => (x.status === "fulfilled" ? (x.value.data.items || []).map((y) => y.full_name || y.path_with_namespace).filter(Boolean) : []))));
    }).catch(() => {});
  }, []);
  const commit = () => { const n = normalize(value); if (n !== value) onChange(n); onSave?.(n); };
  return (
    <label className="mb-3 flex flex-wrap items-center gap-2 rounded-xl border border-[#D9E2F2] bg-[#F5F8FF] px-3 py-2 text-xs text-slate-700" data-testid="wf-repo-field">
      <GitBranch size={14} className="text-[#2F6BFF]" />
      <span className="font-semibold">Repositori</span>
      <span className="text-slate-500">— status pipeline/deploy/test dari webhook GitHub/GitLab masuk ke tahap Vibe Coding alur ini</span>
      <input list="wf-repo-options" value={value || ""} disabled={disabled} onChange={(e) => onChange(e.target.value)} onBlur={commit} onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), commit())}
        placeholder="owner/repo atau URL repositori" className="input-dark min-w-[220px] flex-1 py-1 text-xs" data-testid="wf-repo-input" />
      <datalist id="wf-repo-options">{repos.map((r) => <option key={r} value={r} />)}</datalist>
      {saving ? <Loader2 size={13} className="animate-spin text-slate-400" /> : value ? <Check size={13} className="text-emerald-600" data-testid="wf-repo-linked" /> : null}
    </label>
  );
}

// Standalone variant for running/finished workflows: saves immediately via PUT /tasks/{id}/repo.
export function RepoLink({ task, onDone }) {
  const [value, setValue] = useState(task.repo || "");
  const [saving, setSaving] = useState(false);
  useEffect(() => { setValue(task.repo || ""); }, [task.repo]);
  if (!isDevFlow(task.steps)) return null;
  const save = async (n) => {
    if ((n || "") === (task.repo || "")) return;
    setSaving(true);
    try { await api.put(`/tasks/${task.id}/repo`, { repo: n || null }); toast.success(n ? `Repo ${n} ditautkan ke alur ini` : "Tautan repo dihapus"); onDone?.(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Gagal menautkan repo"); setValue(task.repo || ""); }
    finally { setSaving(false); }
  };
  return <RepoField value={value} onChange={setValue} onSave={save} saving={saving} />;
}
